<template>
  <div
    class="bills-to-card-table-item"
    @click="$emit('click', billsRegistryItem.id)"
  >
    <div class="transaction-table-item">
      <div class="transaction-table-item__short-info">
        <div class="transaction-table-item__col transaction-table-item__date">
          <div class="transaction-table-item__date-main">
            {{ itemDateTime.date }}
          </div>
          <div class="transaction-table-item__date-time">
            {{ itemDateTime.time }}
          </div>
        </div>
        <div
          class="transaction-table-item__col transaction-table-item__recipient"
        >
          <text-input
            :centered="true"
            mode="small"
            v-model:value="billsRegistryItemUpdated.recipient_name"
            :is-error="!!billsRegistryItem.errors.recipient_name || false"
            @textInputBlur="handleUpdateBillsRegistryItem"
          ></text-input>
        </div>
        <div class="transaction-table-item__col transaction-table-item__phone">
          <text-input
            :centered="true"
            mode="small"
            v-model:value="billsRegistryItemUpdated.recipient_phone"
            :is-error="!!billsRegistryItem.errors.recipient_phone || false"
            @textInputBlur="handleUpdateBillsRegistryItem"
          ></text-input>
        </div>
        <div class="transaction-table-item__col transaction-table-item__email">
          <text-input
            :centered="true"
            mode="small"
            v-model:value="billsRegistryItemUpdated.recipient_email"
            :is-error="!!billsRegistryItem.errors.recipient_email || false"
            @textInputBlur="handleUpdateBillsRegistryItem"
          ></text-input>
        </div>
        <div
          class="transaction-table-item__col transaction-table-item__account-number"
        >
          <text-input
            :centered="true"
            mode="small"
            v-model:value="billsRegistryItemUpdated.order_number"
            :is-error="!!billsRegistryItem.errors.order_number || false"
            @textInputBlur="handleUpdateBillsRegistryItem"
          ></text-input>
        </div>
        <div
          class="transaction-table-item__col transaction-table-item__appointment"
        >
          <text-input
            :centered="true"
            mode="small"
            v-model:value="billsRegistryItemUpdated.purpose"
            :is-error="!!billsRegistryItem.errors.purpose || false"
            @textInputBlur="handleUpdateBillsRegistryItem"
          ></text-input>
        </div>
        <div class="transaction-table-item__col transaction-table-item__sum">
          <text-input
            :centered="true"
            mode="small"
            :mask="$options.NUMBER_MASK"
            v-model:value="billsRegistryItemUpdated.sum"
            :is-error="!!billsRegistryItem.errors.sum || false"
            @textInputBlur="handleUpdateBillsRegistryItem"
          ></text-input>
        </div>
        <div class="transaction-table-item__col transaction-table-item__status">
          <transaction-status :status-id="status"></transaction-status>
        </div>
        <div
          class="transaction-table-item__col transaction-table-item__action"
          @click.stop="handleDeleteItem"
        >
          <svg
            width="13"
            height="13"
            viewBox="0 0 13 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="1.47754"
              y1="10.6312"
              x2="11.1087"
              y2="1.00005"
              stroke="#64748B"
              stroke-width="2"
              stroke-linecap="round"
            />
            <line
              x1="1"
              y1="-1"
              x2="14.6205"
              y2="-1"
              transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 11.0449 12.0454)"
              stroke="#64748B"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  $on,
  $off,
  $once,
  $emit,
} from '../../../../../../utils/gogocodeTransfer'
import { CompaniesApi } from '@js-app/office/api/companies-api'
import TransactionStatus from '@vue-app/components/transaction/TransactionStatus.vue'
import { RouteHelper } from '@js-app/services/helpers/routes/routes-helper'
import { mapState } from 'vuex'
import Loader from '@vue-app/components/base/Loader.vue'
import TransactionsTableActionsButton from '@vue-app/components/company/transactions/table/TransactionsTableActionsButton.vue'
import TextInput from '@vue-app/components/base/input/TextInput.vue'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
import { ERROR } from '@js-app/const/operation-statuses-ids'
import moment from 'moment'

export default {
  name: 'BillsRegistryCreatedTableItem',
  props: {
    billsRegistryItem: {
      type: Object,
    },
  },
  components: {
    TextInput,
    TransactionsTableActionsButton,
    Loader,
    TransactionStatus,
  },
  data() {
    return {
      isBillsRegistryItemUpdated: false,
      billsRegistryItemUpdated: {
        ...this.billsRegistryItem,
        sum: this.formatSum(this.billsRegistryItem.sum),
      },
    }
  },
  watch: {
    billsRegistryItemUpdated: {
      handler(old, _new) {
        this.isBillsRegistryItemUpdated = true
      },

      flush: 'post',
      deep: true,
    },
  },
  NUMBER_MASK: createNumberMask({
    prefix: '',
    allowDecimal: true,
    includeThousandsSeparator: false,
    allowNegative: false,
    decimalLimit: 2,
  }),
  computed: {
    ...mapState(['selectedCompany']),
    itemActions() {
      let _actions = []
      return _actions
    },
    commission() {
      return (
        parseInt(this.billsRegistryItemUpdated.commission || 0) / 100
      ).toFixed(2)
    },
    status() {
      if (this.billsRegistryItem.status === 'created') {
        return 0
      }
      if (this.billsRegistryItem.status === 'error') {
        return ERROR
      }

      return this.billsRegistryItem.operation_status_id
    },

    itemDateTime() {
      return {
        date: moment(this.billsRegistryItem.date_update).format('DD.MM.YYYY'),
        time: moment(this.billsRegistryItem.date_update).format('HH:mm:ss'),
      }
    },
  },
  methods: {
    formatSum(sum) {
      const number = parseFloat(sum)
      if (Number.isInteger(number)) {
        return number.toFixed(2)
      }
      return sum
    },

    async handleActionFired(action) {
      try {
        await action.handler()
      } catch (e) {
        console.error(e)
      }

      try {
        this.$refs.transactionItem.actionFinished(action.id)
      } catch (e) {}
    },
    async loadReceipt() {
      let receiptResponse = await CompaniesApi.getBillReceipt(
        this.selectedCompany,
        this.transaction.operationId
      )
      this.transactionReceiptBlob = URL.createObjectURL(receiptResponse.data)
      return this.$refs.transactionReceiptPopup.open()
    },
    toPayoutToCardDetails() {
      this.$router.push(
        RouteHelper.getRoute('payout-to-card-view', {
          companyId: this.selectedCompany,
          payoutId: this.transaction.operationId,
        })
      )
    },
    handleDeleteItem() {
      $emit(this, 'deleted', this.billsRegistryItem)
    },
    handleUpdateBillsRegistryItem() {
      if (this.isBillsRegistryItemUpdated) {
        this.isBillsRegistryItemUpdated = false
        $emit(this, 'update:value', this.billsRegistryItemUpdated)
      }
    },
  },
  emits: ['click', 'deleted', 'update:value'],
}
</script>

<style lang="scss" scoped>
.bills-to-card-table-item {
  .transaction-table-item {
    &__col {
      width: max-content;
    }
    &__short-info {
      display: flex;
      justify-content: space-around;
      align-items: center;
      padding: 20px 50px;
    }
    &__date {
      padding: 0;
      width: 75px;
    }

    &__name {
      word-break: break-all;
      font-weight: 500;
      font-size: 14px;
      line-height: 18px;
      color: #1a1f29;
      opacity: 0.7;
    }

    &__amount {
      font-weight: 600;
      font-size: 14px;
      line-height: 18px;
      color: #1a1f29;
      opacity: 0.7;
      justify-content: flex-end;
    }

    &__commission {
      justify-content: center;
    }

    &__currency {
      justify-content: center;
    }

    &__delete {
      justify-content: center;
    }

    &__status {
      align-self: center;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-left: 20px;
      padding-right: 20px;

      &-item {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 105px;
        max-width: 100%;
        height: 28px;
        border-radius: 6px;
        font-weight: 500;
        font-size: 12px;
        line-height: 28px;

        &--paid {
          background: rgba(39, 204, 36, 0.2);
          color: #44d941;
        }
      }
    }

    &__action {
      cursor: pointer;
    }
  }
}
</style>
